var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool_cell"},[_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v("文字说明\n")])
}]

export { render, staticRenderFns }